module.exports = __webpack_public_path__ + "img/judoinfo-logo.11a3525b.png";